/* eslint-disable quote-props */
export const constant = {
  turnstile: {
    siteKey: '0x4AAAAAABdvkNMFIRUsGUmx',
  },
  recaptcha: {
    siteKey: '6LflL6IaAAAAANz3RydFgSnE-R9y4PewHXJJjDEU',
    invisible: {
      siteKey: '6LdXb0MdAAAAAKdow-ynMWOEgydNgMfJhgpPygF_',
    },
  },
  discountTable: {
    1: 0.1,
    2: 0.15,
    3: 0.2,
    4: 0.25,
    99: 0,
  },
  consumptionTable: {
    1: 0,
    2: 50,
    3: 100,
    4: 150,
    99: 0,
  },
  plans: {
    1: 'R$ 200',
    2: 'R$ 300',
    3: 'R$ 400',
    4: 'R$ 500',
  },
  paydays: [1, 5, 10, 15, 20, 25],
  uf: {
    all: ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'],
    crlve: ['AP', 'BA', 'GO', 'MA', 'MG', 'MT', 'PA', 'PR', 'RN', 'SP', 'TO'],
  },
  colors: ['#f20f68', '#000', '#3c3fa5', '#008080', '#009090', '#00a0a0', '#0e87a6', '#259ebc', '#12a9cf', '#00b7e7', '#00bfff', '#2dc6ed', '#15d4ff', '#6ed8f3'],
  report: {
    items: {
      board: 'Quadro de Avisos',
      boardChassis: 'Quadro - Chassi Remarcado?',
      boardEngine: 'Quadro - Motor Alterado?',
      boardNational: 'Quadro - Restrições Nacionais?',
      boardState: 'Quadro - Restrições Estaduais?',
      decoder: 'Decodificador de Chassi',
      pricer: 'Precificador',
      technicalSpecifications: 'Ficha Técnica',
      equipments: 'Acessórios',
      revisionPlan: 'Plano de Revisão',
      parts: 'Peças',
      register: 'Dados Cadastrais',
      national: 'Dados Nacionais',
      state: 'Dados Estaduais',
      restrictions: 'Restrições',
      owners: 'Proprietários',
      robbery: 'Roubo e Furto',
      auction: 'Leilão',
      auctionChecklist: 'Leilão Checklist',
      auctionAdditional: 'Leilão Informações Adicionais',
      auctionScore: 'Leilão Score',
      auctionPercentage: 'Leilão Percentual',
      auctionSpecialInspection: 'Leilão Vistoria Especial',
      riskAnalysis: 'Análise de Risco',
      casualty: 'Indício de Sinistro',
      km: 'Histórico de KM',
      lien: 'Gravame Detalhado',
      recall: 'Recall',
      renainf: 'Renainf',
      renajud: 'Renajud',
      ads: 'Anúncios',
      photos: 'Fotos',
      debts: 'Débitos e Multas',
      radar: 'Registros de Passagem em Radar',
      csv: 'CSV',
      data: 'Dados Pessoa',
      addresses: 'Endereços',
      emails: 'E-mails',
      phones: 'Telefones',
      capitalStock: 'Capital Social',
      partnerships: 'Sociedades',
      lawSuits: 'Processos Judiciais',
      financialIssues: 'Pendências Financeiras',
      score: 'Score de Crédito'
    },
  },
  inquiry: {
    all: () => {
      let all = {
        ...constant.inquiry.types.vehicle,
      };
      all = Object.assign(all, constant.inquiry.types.credit);
      all = Object.assign(all, constant.inquiry.types.register);
      all = Object.assign(all, constant.inquiry.types.document);
      return all;
    },
    partner: {
      types: ['specialPartner', 'completePartner', 'premium', 'basic', 'auctionSpecialPartner', 'auction', 'auctionBasic', 'lien', 'base', 'national', 'casualty', 'essential', 'crlve', 'creditCpf', 'creditCnpj', 'creditCpfBasic', 'creditCnpjBasic', 'creditScore', 'creditCheck', 'creditActiveDebt', 'creditLaborDebts', 'registerCpf', 'registerCnpj', 'registerCpfBasic', 'registerCnpjBasic'],
    },
    i18n: {
      cyberMonday: 'cyber-monday',
      blackFriday: 'black-friday',
      special: 'especial',
      specialPartner: 'especial',
      complete: 'completa',
      completePartner: 'completa',
      basic: 'basica',
      auctionSpecial: 'leilao-especial',
      auctionSpecialPartner: 'leilao-especial',
      auction: 'leilao-completo',
      auctionBasic: 'leilao-simples',
      lien: 'gravame',
      base: 'dados-basicos',
      national: 'dados-nacionais',
      casualty: 'indicio-sinistro',
      essential: 'essencial',
    },
    details: {
      all: {
        'Número do renavam': 'O Renavam é uma sigla para "Registro Nacional de Veículos Automotores". Trata-se de um número de 11 dígitos armazenado em um banco de dados. Ele registra toda a vida do veículo, desde sua fabricação, quando o fabricante ou importador registrou seus dados originais, passando pelo emplacamento, troca de propriedade, mudança de estado e mudanças de características. O documento acompanha o carro até sair de circulação. O Renavam serve como um número de identidade para o veículo.',
        'Decodificador de chassi': 'O decodificador de chassi é um aliado para identificar uma possível fraude, com ele é possível você validar os dados originais do veículo.<br/><strong>País de fabricação + Fabricante + Modelo + Versão + Ano modelo + Local de Fabricação.</strong>',
        'Dados cadastrais': 'Oferece as informações do cadastro do veículo, nela é possível validar por exemplo a numeração de RENAVAM, remarcação de chassi, número do motor, ano e modelo, cor, tipo do veículo, e outras informações cadastrais.',
        'Dados cadastrais nacionais': 'Oferece as informações do cadastro do veículo em nível nacional, nela é possível validar por exemplo a numeração de RENAVAM, remarcação de chassi, número do motor, ano e modelo, cor, tipo do veículo, e outras informações cadastrais.',
        'Dados cadastrais estaduais': 'Informa os dados do veículo registrados na Base Estadual. Nesta base ficam as características do veículo. Exemplo: Cor e Número do motor.',
        'Restrições e impedimentos': 'Indicador de alguma restrição ativa no veículo nas bases nacionais ou estaduais. As restrições mais comuns são: Alienação Fiduciária, Restrição Administrativa, Roubo e Furto, Arrendamento, Reserva de Domínio, Restrição Judicial.',
        'Gráfico de preço': 'Veja o histórico de preço do veículo nos últimos 12 meses, de acordo com a tabela FIPE. Ótimo para analisar se é o momento da compra ou venda do carro.',
        Precificador: 'De acordo com as tabelas FIPE e MOLICAR, é informado os valores de mercado no exato momento da consulta.',
        'Ficha Técnica': 'Saiba todas informações técnicas do veículo como <strong>consumo</strong>, <strong>desempenho</strong>, <strong>transmissão</strong>, <strong>freios</strong> e <strong>suspensão</strong>.',
        'Acessórios': 'Lista de acessórios e items de série e opcionais do veículo.',
        'Plano de Revisão': 'Veja o Plano de Revisão da montadora para o veículo com: <strong>Quilometragem</strong>, <strong>Preço total e parcelado</strong>, <strong>Peças que devem ser trocadas</strong> e <strong>Itens que devem ser checados</strong> na revisão.',
        'Peças': 'Tenha acesso ao catálogo de peças do veículo com <strong>Código</strong>, <strong>Descrição</strong> e <strong>Nome do Fabricante</strong>.',
        'Risco de comercialização': 'Indicador de algum possível registro no veículo que pode causar a recusa na negociação frente ao mercado.',
        'Aceitação em seguro': 'Indicador de aceitação do veículo nas seguradoras. E a possível interferência do valor, considerando a FIPE e MOLICAR, na cobertura do seguro.',
        'Dados de leilão': 'Histórico de leilão do veículo.<br/><strong>* Pode causar a não aceitação de seguro e a depreciação no valor do veículo.</strong>',
        'Score de leilão': 'Aponta a condição do veículo na data do leilão, ajuda a identificar a origem do leilão, possível aceitação do mercado e uma previsão de oferta em relação a tabela FIPE, além da possibilidade da exigência de uma vistoria especial para aceitação de seguros.',
        'Vistoria especial': 'Indica se o veículo necessita de vistoria especial.<br/><strong>Exemplo: INMETRO e ECV.</strong>',
        'Indício de sinistro': 'Indicador de batidas e/ou reparos com indenização integral ou parcial pela seguradora. Para identificar pequenas batidas e/ou reparos, em que não foi necessário acionar a seguradora, recomendamos que você faça a avaliação física do veículo.',
        'Batidas': 'Indicador de batidas e/ou reparos com indenização integral ou parcial pela seguradora. Para identificar pequenas batidas e/ou reparos, em que não foi necessário acionar a seguradora, recomendamos que você faça a avaliação física do veículo.',
        'Roubo e furto': 'Indicador de ocorrência de roubo ou furto. Caso o veículo possua histórico de roubo e furto essa informação é detalhada na consulta.',
        'Histórico de KM': 'Informação com base nos dados de nossos parceiros sobre todos os registros de quilometragem encontrados, oferecendo ao comprador uma possível identificação de alteração de odômetro.<br/><strong>Informação só constará na consulta caso exista na base de dados de nossos fornecedores parceiros.</strong>',
        Recall: 'Quando há algum defeito na fabricação dos veículos, as montadoras registram uma chamada de Recall para reparo do defeito.<br/><strong>* Importante ficar atento a data limite para o reparo, pois, caso ainda não tenha sido realizado e a data limite já tenha passado, você provavelmente deverá arcar com o custo do reparo.</strong>',
        Gravame: 'Apontamento financeiro ou restritivo do veículo.',
        Remarketing: '"Remarketing" é uma espécie de leilão informal. Muitas vezes, veículos são comercializados em feirões ou eventos afins (o que também pode trazer uma alguma incerteza com relação ao histórico do veículo).<br/><strong>* Nesse item, verificamos se há registro desse tipo de comercialização e, caso positivo, ainda mostramos as fotos (80% dos resultados vêm com fotos).</strong>',
        Multas: 'Informações de multas relacionadas ao veículo.',
        'Histórico de Transferências': 'Aponta ano, município e UF de cada transferência.<br/><strong>Não informamos o nome dos proprietários.</strong><br/><strong>Disponível para veículos a partir de 1980. A informação só constará na consulta caso exista na base de dados de nossos fornecedores parceiros.</strong>',
        'Histórico de Proprietários': 'Histórico de proprietários que o veículo já teve.<br/><strong>Disponível para veículos a partir de 1980. A informação só constará na consulta caso exista na base de dados de nossos fornecedores parceiros.</strong>',
        'Proprietários': 'Quantidade de proprietários que o veículo já teve.<br/><strong>Disponível para veículos a partir de 1980. A informação só constará na consulta caso exista na base de dados de nossos fornecedores parceiros.</strong>',
        'Anúncios': 'Informações de parceiros sobre o veículo.',
        'Anúncios e Fotos': 'Informações de parceiros sobre o veículo.',
        'Débitos e Multas': 'Retornamos apenas as multas que são elegíveis para pagamento no Detran do estado no qual o veículo foi emplacado. Se a multa/infração/autuação estiver em prazo de contestação ou em dívida ativa, é possível que ela não conste no resultado da sua consulta. Ressaltamos que existe mais do que um órgão que atua na aplicação de multas/infrações de veículos e orientamos que seja feita a consulta nos órgãos competentes do seu estado e município, para verificar possíveis autuações ou multas que não constam no Detran.<br/><stromg>A consulta não retorna débitos e multas para os Estados: Acre, Amapá, Amazonas, Pará, Rondônia, Roraima, Sergipe e Tocantins.</strong>',
        'CRLV-e': 'Documento Digital CRLV (Certificado de Registro e Licenciamento do Veículo).',
        'ATPV-e': 'Documento Digital ATPV (Autorização de Transferência de Propriedade do Veículo).',
        'Comunicado de Venda': 'Documento Comunicação de Venda do veículo.',
        'Laudo Analítico - AboutCar AI': 'Não conhece nada sobre avaliação veicular? Fique tranquilo, nossa IA fará a interpretação de todos os dados Técnicos e Históricos contidos no relatório, gerando um Laudo Analítico completo e com linguagem clara, de forma que você entenda tudo relacionado a situação do veículo.',
        CSV: '<strong>Certificado de Segurança Veicular</strong><br/>O CSV é obrigatório para os veículos com configuração de fábrica modificada, como sistema de iluminação, alterações na suspensão e instalação de Gás Natural Veicular (GNV) prevista na Resolução 292/2008.',
      },
      warning: {
        'Histórico de KM': 'somente quando houverem informações disponíveis',
        'Histórico de Transferências': 'somente quando houverem informações disponíveis',
        'Histórico de Proprietários': 'somente quando houverem informações disponíveis',
        'Proprietários': 'restrito a quantidade - sem maiores detalhes',
        'Anúncios': 'somente quando houverem informações disponíveis',
        'Anúncios e Fotos': 'somente quando houverem informações disponíveis',
        'Débitos e Multas': 'somente quando houverem informações disponíveis',
      },
    },
    items: {
      all: [
        'Número do renavam',
        'Decodificador de chassi',
        'Dados cadastrais',
        'Dados cadastrais nacionais',
        'Dados cadastrais estaduais',
        'Restrições e impedimentos',
        'Gráfico de preço',
        'Precificador',
        'Ficha Técnica',
        'Acessórios',
        'Plano de Revisão',
        'Peças',
        'Risco de comercialização',
        'Aceitação em seguro',
        'Dados de leilão',
        'Score de leilão',
        'Vistoria especial',
        'Indício de sinistro',
        'Batidas',
        'Roubo e furto',
        'Recall',
        'Histórico de KM',
        'Gravame',
        'Multas',
        'Débitos e Multas',
        'Histórico de Proprietários',
        'Histórico de Transferências',
        'Proprietários',
        'Anúncios e Fotos',
        'Anúncios',
        'Remarketing',
        'Registros de Passagem em Radar',
        'CSV',
        'Documento Digital',
        'ATPV-e',
        'CRLV-e',
        'Comunicado de Venda',
        'Cotação de Seguro',
        'Laudo Analítico - AboutCar AI',
      ],
      vehicle: [
        'Número do renavam',
        'Decodificador de chassi',
        'Dados cadastrais',
        'Dados cadastrais nacionais',
        'Dados cadastrais estaduais',
        'Restrições e impedimentos',
        'Gráfico de preço',
        'Precificador',
        'Ficha Técnica',
        // 'Acessórios',
        'Plano de Revisão',
        // 'Peças',
        'Risco de comercialização',
        'Aceitação em seguro',
        'Dados de leilão',
        'Score de leilão',
        'Vistoria especial',
        'Indício de sinistro',
        'Batidas',
        'Roubo e furto',
        'Recall',
        'Gravame',
        // 'Multas',
        // 'Remarketing',
        'Histórico de KM',
        'Débitos e Multas',
        'Histórico de Transferências',
        'Proprietários',
        'Anúncios e Fotos',
        'Registros de Passagem em Radar',
        'Multas',
        'Remarketing',
        'CSV',
        'Laudo Analítico - AboutCar AI',
      ],
    },
    types: {
      vehicle: {
        cyberMonday: {
          name: 'Cyber Monday',
          value: 17.90,
          promote: true,
          description: 'Muitas informações com um super desconto. Aproveite!',
          color: '#f20f68',
          customer: true,
        },
        blackFriday: {
          name: 'Black Friday',
          value: 16.90,
          promote: true,
          description: 'Muitas informações com um super desconto. Aproveite!',
          color: '#000',
          customer: true,
        },
        auctionSpecial: {
          name: 'Leilão Especial',
          value: 29.90,
          minimumValue: 15,
          promote: true,
          description: 'Todas as informações sobre leilão do veículo.',
          color: '#3c3fa5',
          customer: true,
          home: true,
        },
        testDrive: {
          name: 'Test Drive',
          description: 'Antes de comprar um veículo, consulte seu histórico.',
          value: 0,
          color: '#006666',
          home: true,
        },
        vehiclePlus: {
          name: 'Veículo Plus',
          value: 67.90,
          minimumValue: 30,
          best: true,
          description: 'Tudo que você precisa saber sobre o veículo.',
          color: '#008080',
          home: true,
          customer: true,
        },
        special: {
          name: 'Especial',
          value: 53.90,
          minimumValue: 30,
          best: true,
          description: 'Tudo sobre o veículo + informações de parceiros.',
          color: '#008080',
          home: true,
          customer: true,
        },
        specialPartner: {
          name: 'Especial',
          value: 53.90,
          minimumValue: 30,
          description: 'Tudo sobre o veículo + informações de parceiros.',
          color: '#008080',
          partner: true,
        },
        complete: {
          name: 'Completa',
          value: 43.90,
          minimumValue: 24,
          description: 'Todas informações disponíveis sobre o veículo.',
          color: '#009090',
          home: true,
          customer: true,
        },
        completePartner: {
          name: 'Completa',
          value: 43.90,
          minimumValue: 24,
          description: 'Todas informações disponíveis sobre o veículo.',
          color: '#009090',
          partner: true,
        },
        premium: {
          name: 'Premium',
          value: 35.90,
          minimumValue: 22,
          description: 'Informações sobre o veículo específicas para parceiros.',
          color: '#009090',
          partner: true,
        },
        basic: {
          name: 'Básica',
          value: 29.90,
          minimumValue: 20,
          description: 'Informações necessárias sobre o veículo.',
          color: '#00a0a0',
          home: true,
        },
        auctionSpecialPartner: {
          name: 'Leilão Especial',
          value: 29.90,
          minimumValue: 15,
          description: 'Informações completas sobre leilão.',
          color: '#0e87a6',
          partner: true,
        },
        auction: {
          name: 'Leilão Completo',
          value: 19.90,
          minimumValue: 13,
          description: 'Informações sobre leilão e indício de sinistro.',
          color: '#259ebc',
          ignore: true,
        },
        auctionBasic: {
          name: 'Leilão Básico',
          value: 12.90,
          minimumValue: 8,
          description: 'Informações sobre leilão e cadastro do veículo.',
          color: '#12a9cf',
          ignore: true,
        },
        lien: {
          name: 'Gravame',
          value: 19.90,
          minimumValue: 7,
          description: 'Informações de financiamento do veículo.',
          color: '#00b7e7',
          home: true,
        },
        base: {
          name: 'Dados Básicos',
          value: 9.90,
          minimumValue: 6.5,
          description: 'Informações do cadastro e restrições do veículo.',
          color: '#00bfff',
          home: true,
        },
        national: {
          name: 'Dados Nacionais',
          value: 8.90,
          minimumValue: 4,
          description: 'Informações do cadastro nacional do veículo.',
          color: '#2dc6ed',
        },
        casualty: {
          name: 'Indício de Sinistro',
          value: 7.90,
          minimumValue: 4,
          description: 'Informações sobre indício de sinistro.',
          color: '#15d4ff',
        },
        essential: {
          name: 'Essencial',
          value: 3.90,
          minimumValue: 1,
          description: 'Informações essenciais sobre o veículo.',
          color: '#6ed8f3',
          home: true,
        },
        transferHistory: {
          name: 'Histórico de Transferência',
          value: 17.90,
          minimumValue: 15.90,
          description: 'Informações essenciais sobre o veículo.',
          color: '#6ed8f3',
          home: true,
        },
        byDocument: {
          name: 'Veículos por CPF',
          value: 32.90,
          minimumValue: 20.90,
          description: 'Informações essenciais sobre o veículo.',
          color: '#6ed8f3',
          home: true,
        },
        debts: {
          name: 'Débitos e Multas',
          value: 14.90,
          minimumValue: 9.90,
          description: 'Informações débitos e multas do veículo.',
          color: '#6ed8f3',
          home: true,
        },
      },
      credit: {
        creditCpf: {
          name: 'CPF Completo',
          value: 29.90,
          minimumValue: 19,
          description: 'Informações completas sobre o crédito de uma pessoa.',
          color: '#008080',
        },
        creditCnpj: {
          name: 'CNPJ Completo',
          value: 35.90,
          minimumValue: 26,
          description: 'Informações completas sobre o crédito de uma empresa.',
          color: '#009090',
        },
        creditCpfBasic: {
          name: 'CPF Básico',
          value: 14.90,
          minimumValue: 10.4,
          description: 'Informações essenciais sobre o crédito de uma pessoa.',
          color: '#00a0a0',
        },
        creditCnpjBasic: {
          name: 'CNPJ Básico',
          value: 14.90,
          minimumValue: 7,
          description: 'Informações essenciais sobre o crédito de uma empresa.',
          color: '#0e87a6',
        },
        creditActiveDebt: {
          name: 'Dívida Ativa',
          value: 6.90,
          minimumValue: 4,
          description: 'Informações sobre o dívidas com a união.',
          color: '#0e87a6',
        },
        creditScore: {
          name: 'Score',
          value: 5.90,
          minimumValue: 3,
          description: 'Informações sobre o Score de uma pessoa ou empresa.',
          color: '#259ebc',
        },
        creditCheck: {
          name: 'Cheque',
          value: 5.90,
          minimumValue: 3,
          description: 'Informações sobre Cheque de uma pessoa ou empresa.',
          color: '#12a9cf',
        },
        creditLaborDebts: {
          name: 'Débitos Trabalhistas',
          value: 5.90,
          minimumValue: 3,
          description: 'Informações sobre o débitos trabalhistas.',
          color: '#00b7e7',
        },
      },
      register: {
        registerCpf: {
          name: 'CPF Completo',
          value: 12.90,
          minimumValue: 7,
          description: 'Informações completas sobre uma pessoa.',
          color: '#008080',
        },
        registerCnpj: {
          name: 'CNPJ Completo',
          value: 12.90,
          minimumValue: 7,
          description: 'Informações completas sobre uma empresa.',
          color: '#009090',
        },
        registerCpfBasic: {
          name: 'CPF Básico',
          value: 8.90,
          minimumValue: 3.9,
          description: 'Informações essenciais sobre uma pessoa.',
          color: '#00a0a0',
        },
        registerCnpjBasic: {
          name: 'CNPJ Básico',
          value: 8.90,
          minimumValue: 3.9,
          description: 'Informações essenciais sobre uma empresa.',
          color: '#0e87a6',
        },
      },
      document: {
        crlve: {
          name: 'CRLV-e',
          value: 23.90,
          minimumValue: 15,
          description: 'Impressão do CRLV-e.',
        },
        sales: {
          name: 'Comunicação Venda',
          value: 79.90,
          minimumValue: 25,
          description: 'Comunicação de Venda.',
        },
      },
    },
    packages: {
      bronze: {
        name: 'Bronze',
        value: 150.00,
        discount: 0.05,
        plan: true,
        color: '#00b7e7',
      },
      silver: {
        name: 'Silver',
        value: 300.00,
        discount: 0.10,
        plan: true,
        color: '#12a9cf',
      },
      gold: {
        name: 'Gold',
        value: 500.00,
        discount: 0.15,
        plan: true,
        color: '#259ebc',
      },
      diamond: {
        name: 'Diamond',
        value: 1000.00,
        discount: 0.2,
        plan: true,
        color: '#0e87a6',
      },
    },
  },
  pagination: {
    limit: 10,
  },
  schedules: {
    '* * * * * *': 'a cada segundo',
    '*/5 * * * * *': 'a cada 5 segundos',
    '*/10 * * * * *': 'a cada 10 segundos',
    '*/15 * * * * *': 'a cada 15 segundos',
    '*/20 * * * * *': 'a cada 20 segundos',
    '*/25 * * * * *': 'a cada 25 segundos',
    '*/30 * * * * *': 'a cada 30 segundos',
    '*/35 * * * * *': 'a cada 35 segundos',
    '*/45 * * * * *': 'a cada 45 segundos',
    '*/50 * * * * *': 'a cada 50 segundos',
    '*/55 * * * * *': 'a cada 55 segundos',
    '* * * * *': 'a cada minuto',
    '*/5 * * * *': 'a cada 5 minutos',
    '*/10 * * * *': 'a cada 10 minutos',
    '*/15 * * * *': 'a cada 15 minutos',
    '*/20 * * * *': 'a cada 20 minutos',
    '*/25 * * * *': 'a cada 25 minutos',
    '*/30 * * * *': 'a cada 30 minutos',
    '*/35 * * * *': 'a cada 35 minutos',
    '*/40 * * * *': 'a cada 40 minutos',
    '*/45 * * * *': 'a cada 45 minutos',
    '*/50 * * * *': 'a cada 50 minutos',
    '*/55 * * * *': 'a cada 55 minutos',
    '0 * * * *': 'a cada hora',
    '0 0 * * *': 'a cada dia',
  },
  redirect: {
    login: '/entrar',
    register: '/cadastrar',
    customer: '/perfil/minha-area',
    leads: '/perfil/leads',
    mix: '/crm/mix'
  }
};
